// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueI18n from 'vue-i18n'
import mui from 'mint-ui'
import '../node_modules/mint-ui/lib/style.css';
import '../node_modules/mint-ui/lib/indicator/style.css';
import '../node_modules/mint-ui/lib/Toast/style.css';
import { Indicator } from 'mint-ui';
import { Toast  } from 'mint-ui';
import EntryAxions from './assets/js/entry.axions.api.js';
import globalConfig from './assets/js/config.file';
import PublicFun from './assets/js/public.fun';
import global_ from './assets/js/Global.js';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.min.css'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import {Calendar} from 'element-ui'
Vue.use(Calendar)
import {Progress} from 'element-ui'
Vue.use(Progress)

Vue.config.productionTip = false
Vue.prototype._Axios = Axios;
Vue.prototype.GLOBAL = global_;
Vue.prototype._EntryAxions = EntryAxions;
Vue.prototype._PublicFun = PublicFun;
Vue.prototype.globalConfig = globalConfig;
Vue.use(VueI18n);
window.Indicator= Indicator;
window.Toast= Toast;
Vue.use(VueAwesomeSwiper)

const i18n = new VueI18n({
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  locale:localStorage.getItem('locale') || 'mm_MY',/*mm_MY*/
  messages: {
    'zh_CN': require('./assets/i18n/zh'), // 中文语言包
    'mm_MY': require('./assets/i18n/my'),//缅文语言包
    'en_WW':require('./assets/i18n/en'),//en_WW英语(全球)
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js